import { liveActivitiesStore } from './fifo'
import { SseEventDtoData, SseEventDtoEvent } from '@/api/model'

const handleLiveActivityEvent = (event: MessageEvent<SseEventDtoData>) => {
  liveActivitiesStore.enqueue({
    id: event.data.id!,
    event: event.data.event!,
    data: event.data,
  })
}

// Слушатели для всех типов событий live activities
const getLiveActivityListeners = (events: SseEventDtoEvent[]) =>
  Object.fromEntries(events.map((event) => [event, handleLiveActivityEvent]))
export const liveActivityListeners = getLiveActivityListeners([
  SseEventDtoEvent.dreamgoal_reached,
  SseEventDtoEvent.dreamunfrozen,
  SseEventDtoEvent.dreamapproved,
  SseEventDtoEvent.donationconfirmed,
])
